import React, { useState, useEffect } from "react";
import "../Style/Footer.css";
import logoMark from "../utils/FotterUper.webp";
import { BsRocketFill } from "react-icons/bs";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleScroll = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-main-content">
          <div className="footer-brand">
            <div className="footer-logo-card">
              <img className="footer-logo-mark" src={logoMark} alt="Teople Technologies logo" />
            </div>
            <h2 className="footer-follow-title">Follow us</h2>
            <div className="footer-social-icons">
              <a href="https://www.facebook.com/profile.php?id=61563310725007" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://x.com/TeopleT" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="https://www.linkedin.com/company/teople-technologies" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
              <a href="https://www.instagram.com/teople_technologies" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          <div className="footer-column footer-links-column">
            <h3>Useful Links</h3>
            <div className="footer-links-grid">
              <div>
                <a href="/">Home</a>
                <a href="/our-work">Our Work</a>
                <a href="/career">Career</a>
                <a href="/contact-us">Contact us</a>
              </div>
              <div>
                <a href="/service-section">Services</a>
                <a href="/about">About us</a>
                <a href="/expertise/java">Our Expertise</a>
                <a href="/blog">Latest Blog</a>
              </div>
            </div>
          </div>

          <div className="footer-column footer-contact-column">
            <h3>Contact Info</h3>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-label">Phone:</span>
                <span className="contact-value">+91 9420206555</span>
              </div>
              <div className="contact-item">
                <span className="contact-label">Email:</span>
                <span className="contact-value">admin@teople.co.in</span>
              </div>
              <div className="contact-item">
                <span className="contact-label">Address:</span>
                <span className="contact-value">102, Raj Residency, Maske Vasti, Ravet, Pimpri-Chinchwad, Maharashtra, 412101</span>
              </div>
              <div className="contact-item">
                <span className="contact-label">Location:</span>
                <div className="footer-map-container">
                  <iframe
                    title="Company Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3780.2490491603683!2d73.7404731!3d18.6581379!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bb540191470f%3A0x4949c74510764f43!2sRaj%20Residency!5e0!3m2!1sen!2sin!4v1721539320000!5m2!1sen!2sin"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        Copyright © 2025, All Rights Reserved
      </div>

      {isVisible && (
        <div className="scroll-to-top" onClick={scrollToTop}>
          <BsRocketFill
            className="scroll-to-top-icon"
            style={{ color: "rgba(143, 232, 255, 1)" }}
          />
        </div>
      )}
    </footer>
  );
};

export default Footer;
